class AnnouncementCountdown extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
  }

  connectedCallback() {
    // Parse date - supports "YYYY-MM-DD HH:MM" or ISO format
    const dateStr = this.dataset.endDate;
    if (dateStr) {
      // Convert "YYYY-MM-DD HH:MM" to ISO format for reliable parsing
      const isoDate = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
      this.endDate = new Date(isoDate);
    } else {
      this.endDate = new Date(NaN);
    }

    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.timerEl = this.querySelector('.announcement-countdown__timer');
    this.showDays = this.daysEl !== null; // If days element exists, we show days

    if (isNaN(this.endDate.getTime())) {
      console.warn('AnnouncementCountdown: Invalid end date');
      return;
    }

    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate.getTime() - now;

    if (distance <= 0) {
      this.handleExpired();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    // If not showing days, add days to hours
    const hours = this.showDays 
      ? Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      : Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = this.showDays ? String(hours).padStart(2, '0') : String(hours);
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  handleExpired() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    this.style.display = 'none';
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
